import { NgModule } from '@angular/core';

import { FileTransfertModule } from './file-transfer/file-transfer.module';
import { ChatModule } from './chat/chat.module';
import { SearchBarModule } from './search-bar/search-bar.module';
import { DateModule } from './date/date.module';
import { IonicIconModule } from './ionic-icon/ionic-icon.module';
import { ActsModules } from './acts/acts.module';
import { AvatarModule } from './avatar/avatar.moule';
import { ConfirmationDialogModule } from './confirmation/confirmation.module';
import { CrossCollectionSelectorModule } from './cross-collection-selector/cross-collection-selector.module';
import { NetworkGraphModule } from './network-graph/network-graph.module';
import { SelectModule } from './select/select.module';
import { ReportModule } from './reports/report.module';
import { RefreshConnexionModule } from './connexion/refresh-connexion.module';
import { StorageModule } from './storage/storage.module';

@NgModule({
  exports: [
    ActsModules,
    AvatarModule,
    ChatModule,
    FileTransfertModule,
    ConfirmationDialogModule,
    CrossCollectionSelectorModule,
    DateModule,
    FileTransfertModule,
    IonicIconModule,
    NetworkGraphModule,
    SearchBarModule,
    SelectModule,
    ReportModule,
    RefreshConnexionModule,
    StorageModule
  ]
})
export class FeaturesModules {}
